/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import type { IType as ProtobufIType } from 'protobufjs';

export type IDescriptorBody = ProtobufIType;

export interface IDescriptorConstructor {
	new( ...args: unknown[] ): Descriptor;

	readonly DESCRIPTOR_NAME: string;

	readonly DESCRIPTOR: IDescriptorBody;
}

export default abstract class Descriptor {
	public declare [ 'constructor' ]: IDescriptorConstructor;

	public static readonly DESCRIPTOR_NAME: string;

	public static readonly DESCRIPTOR: IDescriptorBody;

	// required to allow subclasses to define custom constructor parameters
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor,no-unused-vars
	public constructor( ...args: unknown[] ) {}
}
